//const { get_tokens } = require('./get_tokens');
//const { createCodeVerifier, createCodeChallenge } = require('./pkce');
//const { createState } = require('./state');
const get_tokens = require('./get_tokens').default
const { createCodeVerifier, createCodeChallenge } = require('./pkce')
const { createState } = require("./state")
// const cookie = require('cookie');

// This method is NOT recommended for use in production systems.
const stateStore = new Map();

/**
 * Handles the OAuth flow and returns user data
 * @param {Object} params - The parameters object
 * @param {string} params.environment - The environment URL
 * @param {string} params.client_id - The client ID
 * @param {string} params.client_secret - The client secret
 * @param {string} params.redirect_url - The redirect URL
 * @param {Object} params.req - Express request object
 * @returns {Promise<Object>} User data object or redirect information
 * 
 */
//  const plugin_client_id = process.env.REACT_APP_PLUGIN_CLIENTID;
//  const plugin_client_secret = process.env.REACT_APP_PLUGIN_CLIENTSECRET;
//  const plugin_environment = process.env.REACT_APP_PLUGIN_ENVIRONMENT; 
//  const plugin_redirecturi = process.env.REACT_APP_PLUGIN_REDIRECTURI;

async function handleOAuthFlow(plugin_environment, plugin_client_id, plugin_client_secret, redirect_uri) {
    try {
        let state;
        let codeVerifier;
        let codeChallenge;

        // Temporary debug log
        // console.log('Received Variables Check:', {
        //     plugin_environment: plugin_environment ? 'Set' : 'Not Set',
        //     plugin_client_id: plugin_client_id ? 'Set' : 'Not Set',
        //     plugin_client_secret: plugin_client_secret ? 'Set' : 'Not Set',
        //     redirect_uri: redirect_uri ? 'Set' : 'Not Set'
        // });

          // Get query parameters from URL
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        state = urlParams.get('state');
              
        if (!code || !state) {
            if (state) {
                stateStore.delete(state);
            }

            codeVerifier = createCodeVerifier();
            codeChallenge = createCodeChallenge(codeVerifier);
            state = createState();
            stateStore.set(state, codeVerifier);
            localStorage.setItem(state, codeVerifier);

            const authBaseURL = `${plugin_environment}/a/consumer/api/v0/oidc/auth`;
            const scopesParameterEncoded = `?scope=${encodeURIComponent('openid profile https://api.banno.com/consumer/auth/user.profile.readonly')}`;
            const responseTypeParameter = `&response_type=code`;
            const clientIdParameter = `&client_id=${plugin_client_id}`;
            const redirectUriParameterEncoded = `&redirect_uri=${encodeURIComponent(redirect_uri)}`;

            const stateParameter = `&state=${state}`;

            const claims = {
                'https://api.banno.com/consumer/claim/institution_id': null,
                'https://api.banno.com/consumer/claim/customer_identifier': null
            };

            const claimsToRequest = {
                id_token: claims,
                userinfo: claims
            };

            const claimsParameterValue = encodeURIComponent(JSON.stringify(claimsToRequest));
            const claimsParameter = `&claims=${claimsParameterValue}`;
            const codeChallengeParameter = `&code_challenge=${codeChallenge}`;
            const codeChallengeMethodParameter = `&code_challenge_method=S256`;

            const authorizationURL = `${authBaseURL}${scopesParameterEncoded}${responseTypeParameter}${clientIdParameter}${redirectUriParameterEncoded}${stateParameter}${codeChallengeParameter}${codeChallengeMethodParameter}${claimsParameter}`;
            //console.log('redirect: ',redirect_uri);

            return {
                results: "REDIRECT",
                redirect_url: authorizationURL,
                state: state,
                code_verifier: codeVerifier
            };
        }
        //state = req.state;
        codeVerifier = stateStore.get(state);
        codeVerifier = localStorage.getItem(state);
        //stateStore.delete(state);

        //console.log('redirect: ',redirect_uri);

        const auth_code = code;
        
        const my_tokens = await get_tokens(plugin_environment, plugin_client_id, plugin_client_secret, auth_code, redirect_uri, codeVerifier);
        // Remove ?code=&state= so a page refresh can't replay a used auth code
        window.history.replaceState({}, '', window.location.pathname);
        const { access_token, id_token } = my_tokens;

        const user_id = id_token.sub;

        // Define the partial key name to search for
        const partialKey = 'customer_identifier';

        // Find the full key name
        const fullKey = findKeyByPartialName(id_token, partialKey);    

        return {
            results: "OK",
            error: "",
            member_number: id_token[fullKey] || ""
            // first_name: user_data.firstName || "",
            // middle_name: user_data.middleName || "",
            // last_name: user_data.lastName || "",
            // user_type: user_data.userType || "",
            // user_name: user_data.username || "",
            // phone_number: user_data.phoneNumber || ""
        };
    } catch (error) {
        return {
            results: "ERROR",
            error: error.message,
            member_number: "",
            first_name: "",
            middle_name: "",
            last_name: "",
            user_type: "",
            user_name: "",
            phone_number: ""
        };
    }
}

function findKeyByPartialName(jsonData, partialKey) {
    for (const key in jsonData) {
        //console.log('key: ',key);
        if (key.includes(partialKey)) {
            return key;
        }
    }
    return null;
}

module.exports = { handleOAuthFlow };